export const isDateExpired = (dateString: string | null | undefined): boolean => {
    if (!dateString) return false; // If no date, return false
  
    const endDate = new Date(dateString);
  
    // Get today's date without the time component
    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0); // Set the time to midnight (00:00:00.000)
  
    // Strip the time component from the license end date
    endDate.setHours(0, 0, 0, 0); // Set the time to midnight (00:00:00.000)
  
    return endDate < currentDate; // Compare the dates (ignoring time)
  };
  